<template>
  <v-container fluid fill-height style="display: flex; flex-direction: column; padding: 0; align-content: baseline">
    <div style="width: 300px; height: 100%">
      <v-navigation-drawer permanent="permanent" absolute="" width="300px">
        <v-tabs v-model="tabs" background-color="blue accent-4" class="elevation-2" dark centered icons-and-text>
          <v-tab>
            Info
            <v-icon>mdi-information-outline</v-icon>
          </v-tab>
          <v-tab>
            Layers
            <v-icon>mdi-layers-triple</v-icon>
          </v-tab>
          <v-tab>
            Config
            <v-icon>mdi-cog</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-row>
            <v-col>
              <v-tab-item>
                <v-card class="mx-auto">
                  <v-card-text>
                    <div>Equipment Information</div>
                  </v-card-text>
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>Image Name</v-list-item-title>
                      <v-list-item-subtitle>{{ formatImageNameForDisplay(pano.imageName) }}</v-list-item-subtitle>
                      <hr />
                      <EquipmentDetails :equipment-data="selectedAsset" class="equipment-details" />
                      <ImageDocumentDetails :details="imageDocument && imageDocument.details" />
                      <OverLappingSelector :pano="pano" :platform-id="platformId" />
                      <v-btn v-if="equipmentDataLoaded" @click="info.referDialog.visible = !info.referDialog.visible">
                        {{ numImages }} Images
                      </v-btn>
                      <!-- Button click below only used to display the snackbar with text and type -->
                      <v-btn
                        v-if="equipmentDataLoaded && developerMode"
                        class="clipboard"
                        :data-clipboard-text="JSON.stringify(selectedAsset.data)"
                        @click="handleCopyToClipboardClicked"
                      >
                        <v-icon>mdi-content-copy</v-icon>
                        Equipment Data
                      </v-btn>
                      <v-btn v-if="equipmentDataLoaded" class="clipboard" @click="exportData()">
                        <v-icon>mdi-export</v-icon>
                        Export Data
                      </v-btn>
                      <!-- Button click below only used to display the snackbar with text and type -->
                      <v-btn
                        class="clipboard"
                        :data-clipboard-text="computeClipboard"
                        @click="handleCopyToClipboardClicked"
                      >
                        <v-icon>mdi-content-copy</v-icon>
                        Copy Link
                      </v-btn>
                      <PartForm
                        v-if="equipmentDataLoaded"
                        :active-equipment="selectedAsset"
                        :corrosion-data="corrosionData"
                        :bearing="pano.bearing"
                        :elevation="pano.elevation"
                        :zoom="pano.zoom"
                        :display-snackbar="displaySnackbar"
                        :image-name="formatImageNameForDisplay(pano.imageName)"
                        :inspection-id="platformId"
                      />
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-tab-item>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-tab-item>
                <!-- <v-card-subtitle>Active Layers</v-card-subtitle> -->
                <v-list class="overflow-y-auto">
                  <!-- Corrosion Layer -->
                  <v-list-group :key="0" v-model="ui.corrosionLayer">
                    <template #activator>
                      <v-list-item-icon>
                        <v-tooltip top>
                          <template #activator="{ on }">
                            <v-icon dense @click.stop="corrosion_toggler = !corrosion_toggler" v-on="on">
                              {{ computedCorrosionTogglerStatus['icon'] }}
                            </v-icon>
                          </template>
                          <span>{{ computedCorrosionTogglerStatus['tip'] }}</span>
                        </v-tooltip>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="'Corrosion'" />
                      </v-list-item-content>
                    </template>
                    <SelectionListItem
                      :aggregation="defectLayers"
                      :layers="checkedLayers.defects"
                      checked-layers="defects"
                      :pano="pano"
                      color="blue"
                      @layer-change="handleCheckedLayerChange"
                    />
                  </v-list-group>
                  <!-- Equipment Layer -->
                  <v-list-group :key="1" v-model="ui.equipmentLayer" no-action>
                    <template #activator>
                      <v-list-item-icon>
                        <v-tooltip top>
                          <template #activator="{ on }">
                            <v-icon dense @click.stop="asset_toggler = !asset_toggler" v-on="on">
                              {{ computedAssetTogglerStatus['icon'] }}
                            </v-icon>
                          </template>
                          <span>{{ computedAssetTogglerStatus['tip'] }}</span>
                        </v-tooltip>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="'Equipment'" />
                      </v-list-item-content>
                    </template>
                    <SelectionListItem
                      :aggregation="assetLayers"
                      :layers="checkedLayers.assets"
                      checked-layers="assets"
                      :pano="pano"
                      @layer-change="handleCheckedLayerChange"
                    />
                  </v-list-group>
                  <!-- Line Layer -->
                  <v-list-group v-if="line.points.length" :key="2" v-model="ui.lineLayer" no-action>
                    <template #activator>
                      <v-list-item-icon>
                        <v-tooltip top>
                          <template #activator="{ on }">
                            <v-icon dense @click.stop="line_toggler = !line_toggler" v-on="on">
                              {{ computedLineTogglerStatus['icon'] }}
                            </v-icon>
                          </template>
                          <span>{{ computedLineTogglerStatus['tip'] }}</span>
                        </v-tooltip>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="'Line'" />
                      </v-list-item-content>
                    </template>
                    <SelectionListItem
                      :aggregation="computedLines"
                      :layers="checkedLayers.lines"
                      checked-layers="lines"
                      :pano="pano"
                      color="red"
                      @layer-change="handleCheckedLayerChange"
                    />
                  </v-list-group>
                </v-list>
              </v-tab-item>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-tab-item>
                <!-- <v-card-subtitle>Settings</v-card-subtitle> -->
                <v-list>
                  <v-list-item>
                    <TogglerListItem
                      title="Fill Equipment"
                      :input="assetFillEnabled"
                      @toggle="handleToggleAssetFillEnabled"
                    />
                  </v-list-item>
                  <HighlightStyleSwitcher />
                  <v-list-item>
                    <Slider
                      label="Image Range"
                      :range="neighbouringImagesMaxRange"
                      :initial-value="neighbouringImagesRange"
                      @on-slider-changed="handleNeighbouringImagesRangeChange"
                    />
                  </v-list-item>
                  <v-list-item>
                    <StrokeWidthSlider />
                  </v-list-item>
                </v-list>
              </v-tab-item>
            </v-col>
          </v-row>
        </v-tabs-items>
      </v-navigation-drawer>
    </div>

    <div class="stickyPanoViewer">
      <v-row no-gutter>
        <v-breadcrumbs :items="breadcrumbLinks" />
      </v-row>
      <PanoViewer
        v-if="pano.render"
        ref="pano"
        :source="pano.source"
        :initial="pano.initial"
        :markers="markers"
        :bearing="Number(pano.bearing)"
        :elevation="Number(pano.elevation)"
        :zoom="Number(pano.zoom)"
        :neighbouring-images="neighbouringImages"
        :line="line"
        :checked-lines="checkedLayers.lines"
        :inspection-config="inspectionConfig"
        :display-snackbar="displaySnackbar"
        @marker-selected="handleMarkerSelected"
        @marker-unselected="handleMarkerUnselected"
        @marker-updated="handleMarkerUpdated"
        @lines-updated="handleLineUpdated"
        @position="handlePanoPositionUpdated"
      />
      <v-tooltip top>
        <template #activator="{ on }">
          <v-fab-transition>
            <v-btn
              v-show="neighbourHistory.length"
              absolute
              dark
              fab
              bottom
              right
              color="pink"
              class="mb-10 undo-button"
              v-on="on"
              @click="undoWalkthrough"
            >
              <v-icon>mdi-undo-variant</v-icon>
            </v-btn>
          </v-fab-transition>
        </template>
        <span>Go back</span>
      </v-tooltip>
    </div>

    <v-dialog v-model="info.referDialog.visible" max-width="1200" :retain-focus="false">
      <ReferringImagesTable called-by-spherical-view :data="selectedAsset" @onClose="showReferringImagesTable" />
    </v-dialog>
    <Snackbar :type="snackBarType" :text="snackBarText" @onClose="handleSnackbarClose" />
  </v-container>
</template>

<script>
import { isEmpty, get, debounce } from 'lodash';
import MetricController from '@/controllers/MetricController';
import SelectionListItem from '@/components/widgets/SelectionListItem.vue';
import TogglerListItem from '@/components/widgets/TogglerListItem.vue';
import { OverLappingSelector } from '@/components/overlapping';
import { updateQuery, updateQueries } from '@/utils/queryActions';
import utils, { queryStringBuilder } from '@/utils';
import { formatDistanceMeasurement } from '@/utils/measure';
import {
  PanoViewer,
  EquipmentDetails,
  PartForm,
  ReferringImagesTable,
  ImageDocumentDetails,
  StrokeWidthSlider,
  HighlightStyleSwitcher,
} from '@/components';
// Use notificationType.error to set error type snackbar
import { Snackbar, notificationType, Slider } from '@/components/widgets';

export default {
  name: 'SphericalView',

  components: {
    PanoViewer,
    SelectionListItem,
    TogglerListItem,
    ReferringImagesTable,
    EquipmentDetails,
    PartForm,
    Snackbar,
    ImageDocumentDetails,
    OverLappingSelector,
    StrokeWidthSlider,
    HighlightStyleSwitcher,
    Slider,
  },

  props: {
    // Move to PanoViewerContainer
    inspectionConfig: {
      type: Object,
      default: () => ({}),
    },
    assetFillEnabled: {
      type: Boolean,
      default: false,
    },
    strokeWidth: {
      type: Number,
      default: 0,
    },
    developerMode: {
      type: Boolean,
      default: false,
    },
    snackBarType: {
      type: String,
      default: '',
    },
    snackBarText: {
      type: String,
      default: '',
    },
    selectedEquipmentId: {
      type: String,
      default: null,
    },
    assets: {
      type: Object,
      default: () => ({}),
    },
    checkedLayers: {
      type: Object,
      default: () => ({}),
    },
    platformName: {
      type: String,
      default: '',
    },
    platformId: {
      type: String,
      default: '',
    },
    selectedAsset: {
      type: Object,
      default: () => ({}),
    },
    defectLayers: {
      type: Array,
      default: () => [],
    },
    assetLayers: {
      type: Array,
      default: () => [],
    },
    imageDocument: {
      type: Object,
      default: () => ({}),
    },
    reloadImage: {
      type: Boolean,
      default: false,
    },
    selectedPolygon: {
      type: Object,
      default: () => ({}),
    },
    markers: {
      type: Array,
      default: () => [],
    },
    corrosionData: {
      type: Object,
      default: () => ({}),
    },
    neighbouringImages: {
      type: Array,
      default: () => [],
    },
    neighbouringImagesMaxRange: {
      type: Number,
      default: 10,
    },
    neighbouringImagesRange: {
      type: Number,
      default: 10,
    },
  },

  data() {
    return {
      ui: {
        corrosionLayer: true,
        equipmentLayer: false,
        lineLayer: true,
      },
      corrosion_toggler: false,
      asset_toggler: false,
      line_toggler: false,
      toggler_button_status: 1,
      info: {
        equipmentData: {},
        referDialog: {
          visible: false,
        },
        partForm: {
          visible: false,
        },
      },
      pano: {
        imageName: '',
        source: '',
        markers: [],
        bearing: 0,
        elevation: 0,
        zoom: 0,
        highlightedPoly: {
          id: '',
          lineAssetIds: new Set(),
          annotationId: null,
        },
        render: false,
        initial: {
          bearing: 0,
          elevation: 0,
          zoom: 0,
          markerId: '',
        },
      },
      breadCrumbText: '',
      tabs: 0,
      tabsEnum: {
        info: 0,
        layers: 1,
        config: 2,
      },
      urlSnap: {
        imagePath: '',
        inspection_uuid: '',
      },
      neighbourHistory: [],
      line: {
        points: [], // lines in pano viewer
        measurements: [], // measurements for lines
      },
      togglerIconAndTip: {
        noneEnabled: { icon: 'mdi-checkbox-blank-outline', tip: 'Enable All' },
        someEnabled: { icon: 'mdi-checkbox-intermediate', tip: 'Enable All' },
        allEnabled: { icon: 'mdi-checkbox-marked', tip: 'Disable All' },
      },
    };
  },
  computed: {
    breadcrumbLinks() {
      return [
        {
          text: 'Dashboard',
          disabled: false,
          to: '/',
        },
        {
          text: this.platformName,
          disabled: false,
          to: `/inspection?id=${this.platformId}`,
        },
        {
          text: this.breadCrumbText,
          disabled: true,
        },
      ];
    },
    computedCorrosionTogglerStatus() {
      return this.toComputeTogglerStatus(this.defectLayers, 'defects');
    },
    computedAssetTogglerStatus() {
      return this.toComputeTogglerStatus(this.assetLayers, 'assets');
    },
    computedLineTogglerStatus() {
      return this.toComputeTogglerStatus(this.line.points, 'lines');
    },
    computedLines() {
      return this.line.points.map((l, idx) => {
        let formatDistance = '';
        if (this.line.measurements[idx] !== undefined) {
          formatDistance = formatDistanceMeasurement({
            meters: this.line.measurements[idx],
            unit: this.$store.state.unit,
            displayUnit: true,
          });
        }

        return {
          name: `line_${idx}`,
          friendlyName: `line_${idx} ${formatDistance}`,
          color: 'green',
        };
      });
    },

    numImages() {
      return get(this.selectedAsset, 'data.referring_images.length', 0);
    },

    corrosionSet() {
      return new Set(this.defectLayers.map((e) => e.name));
    },

    equipmentSet() {
      return new Set(this.assetLayers.map((e) => e.name));
    },

    computeClipboard() {
      const queryParameters = {
        id: this.$route.query.id,
        path: this.urlSnap.imagePath,
        inspection_uuid: this.urlSnap.inspection_uuid,
        bearing: this.pano.bearing.toFixed(3),
        elevation: this.pano.elevation.toFixed(3),
        zoom: this.pano.zoom.toFixed(3),
        equipid: this.$route.query.equipid,
      };
      const queryString = queryStringBuilder(queryParameters);
      return `${window.location.protocol}//${window.location.host}/spherical?${queryString}`;
    },

    equipmentDataLoaded() {
      return !isEmpty(this.selectedAsset);
    },
  },

  watch: {
    selectedPolygon(value) {
      this.switchTabTo(this.tabsEnum.info);
      this.pano.highlightedPoly = value;
    },
    selectedEquipmentId(value) {
      updateQuery('equipid', value);
      this.$emit('onUpdateMarkers');
    },
    // update line markers and tooltips on unit switch
    '$store.state.unit': function () {
      this.handleMarkerUpdated();
    },
    '$route.query': function routeQueryWatcher(current, previous) {
      if (current.image !== previous.image) {
        this.showReferringImagesTable(false);
        this.$emit('onLoadURLQuery', { loadAssets: true });
      } else if (current.id !== previous.id) {
        this.$emit('onLoadURLQuery');
      }
    },
    // @J monitor togglers
    corrosion_toggler() {
      this.filterTogglerAlt(this.defectLayers, 'defects');
    },
    asset_toggler() {
      this.filterTogglerAlt(this.assetLayers, 'assets');
    },
    line_toggler() {
      this.filterTogglerAlt(this.computedLines, 'lines');
    },
    strokeWidth() {
      this.$emit('onUpdateMarkers');
    },
    'checkedLayers.lines': function checkedLayersLines() {
      this.handleMarkerUpdated();
    },
    reloadImage(value) {
      if (value) {
        this.loadImage(this.imageDocument);
      }
    },
  },

  async mounted() {
    const { path, inspection_uuid: inspection } = this.$route.query;
    if (path && inspection) {
      const { data, error } = await MetricController.lookupSpherical(inspection, path);
      if (error) {
        this.handleError(error);
      } else {
        this.$route.query.image = data._id;
      }
    }

    this.loadImage(this.imageDocument);
  },
  created() {
    window.addEventListener('keyup', this.onKey);
  },
  destroyed() {
    window.removeEventListener('keyup', this.onKey);
  },
  methods: {
    updateURL: debounce(({ bearing, elevation, zoom }) => {
      updateQueries(['bearing', 'elevation', 'zoom'], [bearing, elevation, zoom]);
    }, 300),

    formatImageNameForDisplay: utils.formatImageNameForDisplay,

    handleCheckedLayerChange(layer, layerStatus) {
      this.$emit('onUpdateCheckedLayers', { layer, layerStatus });
    },

    undoWalkthrough() {
      const image = this.neighbourHistory.pop();
      if (image) {
        this.imageClicked(image, false);
        this.cleanupPano();
        this.$emit('onLoadURLQuery', { loadAssets: true });
      }
    },

    exportData() {
      utils.exportTableToCSV(
        utils.equipmentCsvDataCleaner(this.selectedAsset.data),
        this.selectedAsset.data.meta['AutoCad:Tag']
      );
    },

    showReferringImagesTable(params) {
      this.info.referDialog.visible = params;
    },

    onKey(key) {
      // @J Key binds
      switch (key.code) {
        case 'KeyC': // alt + c
          if (key.altKey) this.corrosion_toggler = !this.corrosion_toggler;
          break;
        case 'KeyA': // alt + a
          if (key.altKey) this.asset_toggler = !this.asset_toggler;
          break;
        default:
          break;
      }
      // End
      key.preventDefault();
    },

    // Toggler function used for corrosion and asset filters
    filterTogglerAlt(originData, layer) {
      const layerStatus =
        this.checkedLayers[layer].length === originData.length ? [] : originData.map(({ name }) => name);
      this.$emit('onUpdateCheckedLayers', { layer, layerStatus });
    },
    // End
    toComputeTogglerStatus(originData, layer) {
      switch (this.checkedLayers[layer].length) {
        case 0:
          return this.togglerIconAndTip.noneEnabled;
        case originData.length:
          return this.togglerIconAndTip.allEnabled;
        default:
          return this.togglerIconAndTip.someEnabled;
      }
    },

    findAsset(assetList, target) {
      return assetList.find(({ equipment_id }) => equipment_id === target);
    },

    updateInitialCameraDirectionByQuery() {
      let { isNumeric, value } = utils.checkNumeric(this.$route.query.elevation);
      if (isNumeric) {
        this.pano.initial.elevation = value;
      }
      ({ isNumeric, value } = utils.checkNumeric(this.$route.query.bearing));
      if (isNumeric) {
        this.pano.initial.bearing = value;
      }
      ({ isNumeric, value } = utils.checkNumeric(this.$route.query.zoom));
      if (isNumeric) {
        this.pano.initial.zoom = value;
      }
    },

    loadImage(imageDocument) {
      this.urlSnap.imagePath = imageDocument.name;
      this.urlSnap.inspection_uuid = imageDocument.inspection_uuid;
      this.breadCrumbText = utils.formatImageNameForDisplay(imageDocument.name);

      if (this.$route.query.equipid) {
        this.$emit('onSelectEquipmentId', this.$route.query.equipid);
        const asset = this.findAsset(imageDocument.data.assets, this.$route.query.equipid);
        this.pano.initial.equipmentId = this.$route.query.equipid;
        if (asset && !this.$route.query.bearing && !this.$route.query.elevation && !this.$route.query.zoom) {
          this.pano.initial.bearing = +asset.polar.centroid[0];
          this.pano.initial.elevation = -asset.polar.centroid[1];
          // align pano information
          this.pano.bearing = +asset.polar.centroid[0];
          this.pano.elevation = -asset.polar.centroid[1];
        } else {
          this.updateInitialCameraDirectionByQuery();
        }
      } else {
        this.updateInitialCameraDirectionByQuery();
      }

      this.pano.source = imageDocument.data.resource;
      [this.pano.imageName] = this.pano.source.split('/').slice(-1);

      this.pano.coverage = get(imageDocument, 'data.metrics.coverage');

      this.populateLayers(imageDocument);
    },

    sectorClicked(angle) {
      this.pano.bearing = angle;
    },

    populateLayers() {
      this.$emit('onUpdateLayers');
      if (this.$route.query.nolayers) {
        this.$emit('onUpdateCheckedLayers', {
          layer: 'defects',
          layerStatus: [],
        });
        this.$emit('onUpdateCheckedLayers', {
          layer: 'assets',
          layerStatus: [],
        });
      } else {
        this.$emit('onUpdateCheckedLayers', {
          layer: 'assets',
          layerStatus: this.assetLayers.map(({ name }) => name),
        });
      }

      this.pano.render = true;
    },

    handleMarkerSelected({ id }) {
      if (id === undefined) {
        return;
      }

      const [startsWith, target] = id.split('_');
      switch (startsWith) {
        case 'neighbour': // handle walkthrough icon click
          this.imageClicked(target);
          break;
        case 'line': {
          const status = this.$refs.pano.selectLineMarker(target);
          const snackbarMessage = status ? 'Selected annotation (DEL to delete)' : 'Unselected annotation';
          this.displaySnackbar(snackbarMessage);
          this.switchTabTo(this.tabsEnum.layers);
          break;
        }
        case 'lineend': // handle line annotation end click
          this.$refs.pano.selectLineMarker(target);
          this.switchTabTo(this.tabsEnum.layers);
          break;
        default:
          this.$emit('onSelectMarker', {
            markerId: id,
            ctrlKey: get(window, 'event.ctrlKey'),
          });
      }
    },

    handleMarkerUnselected() {
      this.$emit('onClearSelectedPoly');
    },

    handleMarkerUpdated() {
      this.$emit('onUpdateMarkers');
    },
    handleToggleAssetFillEnabled() {
      this.$emit('onToggleAssetFillEnabled');
    },
    handleLineUpdated(line) {
      this.line = line;
      this.$emit('onUpdateCheckedLayers', {
        layer: 'lines',
        layerStatus: this.line.points.map((_, index) => `line_${index}`),
      });
      this.switchTabTo(this.tabsEnum.layers);
      this.ui.lineLayer = true;
    },

    handlePanoPositionUpdated({ longitude: bearing, latitude: elevation, zoom }) {
      this.pano.bearing = bearing;
      this.pano.elevation = elevation;
      this.pano.zoom = zoom;
      this.updateURL({ bearing, elevation, zoom });
    },

    cleanupPano() {
      this.$refs.pano.clearAnnotations();
    },

    imageClicked(imageId, pushHistory = true) {
      if (pushHistory && this.$route.query.image) {
        this.neighbourHistory.push(this.$route.query.image);
      }
      // clear
      this.cleanupPano();
      this.$router.replace({ query: { ...this.$route.query, image: imageId } });
    },

    switchTabTo(tab) {
      this.tabs = tab;
    },

    handleError(error) {
      this.displaySnackbar(get(error, 'response.data.message', error.message), notificationType.error);
    },

    handleCopyToClipboardClicked() {
      this.displaySnackbar('Copied to clipboard!');
    },

    handleNeighbouringImagesRangeChange(value) {
      this.$emit('onNeighbouringImagesRangeChange', value);
    },

    displaySnackbar(message, type) {
      this.$emit('onSnackbarDisplay', message, type);
    },

    handleSnackbarClose() {
      this.$emit('onSnackbarClose');
    },
  },
};
</script>

<style scoped lang="less">
.rig {
  padding-left: 5px;
}

.layers {
  span {
    min-width: 100%;
    display: inline-block;
  }
}

.panoview {
  margin-top: 15px;
  min-height: 80vh;
  // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}

.rad-indicator {
  padding: 10%;
  // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}

.widget {
  // padding:20px;
  padding-top: 5px;
  padding-left: 20px;
  padding-bottom: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  margin-bottom: 15px;
  border-radius: 5px;
}

.sidebar {
  padding: 10px;
}

.info-card {
  max-height: 30vh;
  overflow-y: scroll;
}

.stickyPanoViewer {
  padding: 1px;
  width: calc(100% - 300px);
  height: 100%;
  position: sticky;
  top: 45px;
}

.undo-button {
  z-index: 10000;
}

.equipment-details {
  overflow: hidden;
}
</style>
